import AsyncStorage from "@react-native-async-storage/async-storage";
import { atom } from "jotai";
import { atomFamily, atomWithStorage, createJSONStorage } from "jotai/utils";

export const selectedCoursesByFacility = atomFamily((facilityID: string) => {
  const storage = createJSONStorage<Record<string, boolean> | null>(
    () => AsyncStorage
  );
  return atomWithStorage<Record<string, boolean> | null>(
    `${facilityID}:selectedCoursesByFacility`,
    null,
    storage,
    { getOnInit: true }
  );
});

export const selectedCourseIdsByFacility = atomFamily((facilityID: string) => {
  const derivedAtom = atom(async (get) => {
    const courseWithVisibility = await get(
      selectedCoursesByFacility(facilityID)
    );

    return courseWithVisibility
      ? Object.keys(courseWithVisibility).filter(
          (key) => courseWithVisibility[key] === true
        )
      : [];
  });

  return derivedAtom;
});
